import { render, staticRenderFns } from "./activities-anniversary.vue?vue&type=template&id=66794380&scoped=true&"
import script from "./activities-anniversary.vue?vue&type=script&lang=js&"
export * from "./activities-anniversary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66794380",
  null
  
)

export default component.exports